
import './custom-table.css';

import angular from 'angular';
import smartTable from 'angular-smart-table';

import customTable from './custom-table';
import CustomTableController from './custom-table.controller';

import percentageFilter from '../../filter/percentage';
import currencyFilter from '../../filter/currency';

export default angular.module('directive.custom-table', [
		percentageFilter,
		currencyFilter,
		smartTable
	])
	.controller('CustomTableController', CustomTableController)
	.directive('customTable', customTable)
	.name;



// WEBPACK FOOTER //
// ./src/directive/custom-table/index.js